var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2743",
    "data-name": "Grupo 2743",
    transform: "translate(-0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1288",
    "data-name": "Ret\\xE2ngulo 1288",
    width: 35,
    height: 35,
    rx: 10,
    transform: "translate(0.5)",
    fill: "#d3ff9a",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2695",
    "data-name": "Grupo 2695",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_768",
    "data-name": "Caminho 768",
    d: "M21.251,6.5a2.476,2.476,0,0,1,1.678.642,2.11,2.11,0,0,1,.695,1.549V19.647a2.11,2.11,0,0,1-.695,1.549,2.476,2.476,0,0,1-1.678.642H17.693L14.972,24.35a1.233,1.233,0,0,1-.764.319,1.255,1.255,0,0,1-.8-.228l-.112-.091-2.721-2.513H7.015A2.476,2.476,0,0,1,5.338,21.2a2.11,2.11,0,0,1-.695-1.549V8.691a2.11,2.11,0,0,1,.695-1.549A2.476,2.476,0,0,1,7.015,6.5Z",
    transform: "translate(-4.643 -6.5)",
    fill: "none",
    stroke: "#d3ff9a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_769",
    "data-name": "Caminho 769",
    d: "M15.691,19.834a1.1,1.1,0,1,0,0-2.191,1.1,1.1,0,0,0,0,2.191Zm-4.382,0a1.1,1.1,0,0,0,0-2.191,1.1,1.1,0,0,0,0,2.191Zm8.764,0a1.1,1.1,0,1,0-1.094-1.1A1.178,1.178,0,0,0,20.073,19.834Z",
    transform: "translate(-6.205 -11.07)",
    fill: "#d3ff9a",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.00bf7c609927199b0acea33bd881a521.svg";
export { ForwardRef as ReactComponent };